import { render, staticRenderFns } from "./alternate_device_modify.vue?vue&type=template&id=24aea4a0&scoped=true&"
import script from "./alternate_device_modify.vue?vue&type=script&lang=js&"
export * from "./alternate_device_modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aea4a0",
  null
  
)

export default component.exports